import React from "react";
import type { DocumentCreationViewProps } from "@ps-bridge/contracts/documentCreation";
import type { DocumentMetadata } from "@ps-bridge/models/core/dataContracts";
import * as styles from "@styles/DocumentCreation.css";
import DocumentCreationReviewPanel, {
  type DocumentCreationReviewOutlineExtraPhase,
  type DocumentCreationReviewOutlinePhase,
} from "@view/panels/workspace/document-creation/DocumentCreationReview.panel";

type DocumentCreationReviewContractProps = Pick<DocumentCreationViewProps, never>;

type DocumentCreationReviewViewProps = DocumentCreationReviewContractProps & {
  titleValue: string;
  styleValue: string;
  outlineLines: string[];
  selectedSourceDocuments: DocumentMetadata[];
};

const DocumentCreationReviewView: React.FC<DocumentCreationReviewViewProps> = ({
  titleValue,
  styleValue,
  outlineLines,
  selectedSourceDocuments,
}) => {
  const titleText =
    titleValue.trim().length > 0 ? titleValue : "Untitled draft";
  const styleText =
    styleValue.trim().length > 0
      ? styleValue
      : "No specific tone notes provided.";
  const outlinePreviewLines = outlineLines.slice(0, 6);
  const outlineExtraCount = Math.max(outlineLines.length - 6, 0);
  const outlinePhase: DocumentCreationReviewOutlinePhase =
    outlineLines.length > 0 ? "list" : "empty";
  const outlineExtraPhase: DocumentCreationReviewOutlineExtraPhase =
    outlineExtraCount > 0 ? "visible" : "hidden";

  return (
    <>
      <DocumentCreationReviewPanel
        titleText={titleText}
        styleText={styleText}
        outlinePreviewLines={outlinePreviewLines}
        outlineExtraCount={outlineExtraCount}
        outlinePhase={outlinePhase}
        outlineExtraPhase={outlineExtraPhase}
      />
      <div className={styles.reviewBlock}>
        <p className={styles.reviewLabel}>Source documents</p>
        <ul className={styles.sourceReviewList}>
          {selectedSourceDocuments.map((document, index) => (
            <li key={document.id} className={styles.sourceReviewItem}>
              <span>{index + 1}</span>
              <span>{document.name}</span>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default DocumentCreationReviewView;
